module.exports = __webpack_public_path__ + "img/yc-line-2-3.svg";